


































import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({name: 'compendium-table-view',})
export default class CompendiumTableView extends Vue {
  @Prop({
    type: Array,
    required: true,
  })
  readonly headers: string[]

  @Prop({
    type: Array,
    required: true,
  })
  readonly items: any[]

  itemType = ''
  tableHeight = 500

  mounted() {
    this.onResize()
  }

  customSort(items, index, descending) {
    const desc = descending[0]
    items.sort((a, b) => {
      index.forEach(idx => {
        if (idx === 'Damage') {
          return desc ? b.MaxDamage - a.MaxDamage : a.MaxDamage - b.MaxDamage
        } else if (idx === 'Range') {
          return desc ? b.Range[0].Max - a.Range[0].Max : a.Range[0].Max - b.Range[0].Max
        } else {
          return desc ? (a[idx] < b[idx] ? -1 : 1) : b[idx] < a[idx] ? -1 : 1
        }
      })
    })
    return items
  }

  onResize() {
    this.tableHeight = window.innerHeight - 160
  }
}
